<template>
  <div class="gywm-container">
    <Layout height="520px" :imgsrc="gywm" :filter="filterNumber" title="关于我们">
        <template>
          <div class="introduce-box">
          
            <div class="box-body">
              <div class="box-title">
                <img :src="logo" alt="">
              <p>企业介绍</p>
              </div>
              <div class="box-content">
                <p>内江数循数字科技有限公司成立于2023年6月，是内江市高新区重点培育扶持的创新创业型科技企业。</p>
                <p>内江数循将基于区块链和隐私计算研发可信传输、可信存储和可信计算等开放工具，为公共、企业、个人数字提供安全可靠，自主可控的数据流通技术；为数据资产的保值、增值提供数据资产代加工、AI产品代训练等服务。</p>
              </div>
            </div>
          </div>
        </template>
    </Layout>
    <div class="Course">
<div class="Course-left">

  <div class="List-box">
    <ul ref="select" :style="{'marginTop':count*-100+200+'px'}" class="selectUl">
      <li v-for="(it,index) in timer" :key="index" :class="[count===index?'active':'List-box-li']">{{it}}</li>
    </ul>
   <div class="selectBox">
    <div class="btnup" @click="handclick(count-=1)">
      <i class="iconfont icon-xiangshang"></i>
    </div>
    <div :class="[DateList[count]!==null ? 'selectBox-after-content':'selectBox-after']" >{{DateList[count]}}</div>
    <div class="selectBox-befor" v-if="isShow"></div>
    <div class="btndown" @click="handclick(count+=1)">
      <i class="iconfont icon-xiangxia"></i>
    </div>
   </div>
  </div>
</div>
<div class="Course-right">
 
   <div class="Course-right-body" >
    <p>{{contentList[count].title}}</p>
    <ul>
      <li v-for="(item,index) in contentList[count].data" :key="index">{{item}}</li>
    </ul>
   </div>
</div>
 
    </div>
    <Honor :imglist="imgList" title="企业荣誉"/>
  </div>
</template>

<script>
import logo from "@/assets1/关于我们_slices/67890备份.png"
import imgSrc from "@/assets/证书.png"
import Honor from "./compoents/Honor.vue"
import Layout from '@/components/Layout.vue'
// import GYWM from "@/assets1/关于我们_slices/关于我们banner.png"
import imgIcon from "@/assets1/关于我们_slices/背景icon.png"
export default {
  components: { Layout,Honor },
  data(){
    return{
      logo,
      imgIcon:`url(${imgIcon})`,
       gywm:'https://sxoffcia.oss-cn-chengdu.aliyuncs.com/offcia_Img/%E5%85%B3%E4%BA%8E%E6%88%91%E4%BB%AC/%E5%85%B3%E4%BA%8E%E6%88%91%E4%BB%ACbanner.png',
       filterNumber:0,
       timer:['2023.06','2024.04','2024.07','2024.12'],
       contentList:[
        {title:'发展历程',data:['公司成立']},
        {title:'发展历程',data:['2023.7 发明专利授权','2023.11 数字四川创新大赛2023 数据交易赛道 三等奖',
'2023.12 第五届内江高新杯创客大赛 三等奖' ]}
,{title:'发展历程',data:['完成种子轮融资','内江师范学院签订实践教学基地',
'2024. 5 获得内江市就业实践基地','2024.6 第六届“中国创翼大赛”四川赛区内江选拔赛 一等奖','2024.6 发明专利授权'

       ]}
       ,{title:'发展历程',data:['2024.7 数字镖局公开测试版本上线','2024年8月 创新四川.创业天府 三等奖',
'2024.12 数据资源超市上线'

       ]}],
       count:0,
       imgList:[imgSrc,imgSrc,imgSrc,imgSrc,imgSrc],
       isShow:true,
       DateList:[null,'2023.06','2024.04','2024.07','2024.12']
    }
    
  },
  methods:{
    handclick(it){
    
      
      if(it<0){
        this.count=0
        return
      }
      if(it>4){
        this.count=4
        return
      }
      this.isShow=false
      this.count=it

    },
    isShowFn(){
      
      
      this.$refs.select.addEventListener('transitionend',()=>{
        this.isShow=true
        console.log(1);
        
      })
    }
  },
  mounted(){
    this.isShowFn()
  }
}
</script>

<style scoped>
.gywm-container{
  width: 1920px;
  
}

/* .active::after{
  content: '';
  position: absolute;
  width: 100px;
  height: 1px;
  background-color: #fff;
  left: 50%;
  top: 50%;
  transform: translate(-50%,-50%);
  transition: none;
}
.active::before{
  content: '';
  position: absolute;
  width: 3px;
  height: 35px;
  background-color: #fff;
  right: -1px;
  top: 50%;
  transform: translateY(-50%);
  transition: none;
} */
.selectBox-after-content{
  position: absolute;
  width: 100px;
  color: #fff;
  left: 50%;
  top: 50%;
  transform: translate(-50%,-50%);
 
  transition: none;
  font-family: Regular;
font-weight: 500;
font-size: 30px;
}

 .selectBox-after{
  content: '';
  position: absolute;
  width: 100px;
  height: 1px;
  background-color: #fff;
  left: 50%;
  top: 50%;
  transform: translate(-50%,-50%);
  transition: none;
 }
 .selectBox-befor{
   content: '';
  position: absolute;
  width: 3px;
  height: 35px;
  background-color: #fff;
  right: -1px;
  top: 50%;
  transform: translateY(-50%);
  transition: none;
 }
.selectUl{
  transition: 0.2s linear;
  font-family: Light;
}
.active{
 width: 100%;
  font-family: Regular;
font-weight: 500;
font-size: 30px;
color: #FFFFFF;
  height: 100px;
  line-height: 100px;
  color: #fff;
  text-align: end;
  padding-right: 100px;
   position: relative;
}
.icon-xiangshang{
  font-size: 15px;
  font-weight: 600;
}
.icon-xiangxia{
   font-size: 15px;
  font-weight: 600;
}

.btndown{
 
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: #153cc5;position: absolute;
  left: 50%;
  color: #fff;
  transform: translateX(-50%);
  bottom: -20px;
}
.btndown:hover{
 color:  #3962e3;
  background-color:#fff;
  cursor: pointer;
}
.btndown i{
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%,-50%);
}

.btnup{
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: #153cc5;position: absolute;
  left: 50%;
  color: #fff;
  transform: translateX(-50%);
  top: -20px;
}
.btnup:hover{
 color:  #3962e3;
  background-color:#fff;
  cursor: pointer;
}
.btnup i{
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%,-50%);
}
.selectBox{
  top: 50%;
  left: 0;
  position: absolute;
  width: 100%;
  border-top:1px solid #4c75f8;
  border-bottom:1px solid #4c75f8;
   height: 100px;
  line-height: 100px;
  transform: translateY(-50%);
}
.Course-right-body{

}
.List-box-li{
  width: 100%;
font-family: PingFangSC, PingFang SC;
font-weight: 400;
font-size: 26px;
color: #FFFFFF;
  height: 100px;
  line-height: 100px;
  color: #748cfc;
  text-align: end;
  padding-right: 100px;
   /* background-color: #fff; */
}
.List-box{
  position: absolute;
  height: 500px;
  width: 100%;
top: 50%;
left: 0;
transform: translateY(-40%);
  overflow: hidden;
 
}
.selectBox{
  position: absolute;

}
.Course-left{
  flex: 4.25;

  overflow: hidden;
  position: relative;
  padding-top: 208px;
}

.Course-right{
 
  flex: 5.5;

  overflow: hidden;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-left: 100px;

}
.Course-right p{
  font-family: Medium;
font-weight: 500;
font-size: 36px;
color: #17213C;
  margin-bottom: 37px;
}
.Course-right li{
  margin-left: 25px;
font-family: Regular;
font-weight: 400;
font-size: 18px;
color: #838690;
margin-bottom: 24px;
position: relative;
}
.Course-right li::after{
 content: '';
 width: 8px;height: 8px;
 border-radius: 50%;
 background-color: #0a54ff;
 position: absolute;
 left: -20px;
 top: 50%;
 transform: translateY(-50%);
}
.Course-right li:last-child{

margin-bottom: 0px;
}
.Course{
  width: 100%;
  height: 829px;
  display: flex;
  background-image: url('https://sxoffcia.oss-cn-chengdu.aliyuncs.com/offcia_Img/%E5%85%B3%E4%BA%8E%E6%88%91%E4%BB%AC/%E5%9C%B0%E5%9B%BE%E8%83%8C%E6%99%AF.png');
  background-size: cover;
  }
.box-content{width: 1040px; 
font-family:Regular;
font-weight: 400;
font-size: 18px;
color: #5A6068;
line-height: 25px;
}
.box-content p{
  margin-bottom: 35px;
  letter-spacing: 1px;
}
.box-content p:last-child{
    margin-bottom: 0px;
}
.box-body{
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%,-50%);
   z-index: 5;
}
.logo{
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 1;
}
.box-title img{
  width: 29px;
  height: 40px;
  object-fit: cover;
  margin-right: 24px;
}
.box-title {
 display: flex;
 justify-content: center;
 margin-bottom: 45px;
}
.box-title .iconfont{
  font-size: 42px;
  color: #1841d7;
  margin-right: 20px;
}
.box-title p{
font-family: Medium;
font-weight: 500;
font-size: 30px;
color: #17213C;
}
.introduce-box{
  width: 1200px;
  height: 342px;
  background-image: v-bind(imgIcon);
  overflow: hidden;
  position: relative;
}
.logo .icon-github{
  color: #f9f9f9;
  text-shadow: 0 0 2px rgba(0, 0, 0, .3);
}
.logo>i:nth-child(1){
  font-size: 200px;
  left: -20px;
  position: absolute;top: -20px;
  transform: rotate(45deg);
  z-index: 1;
}
.logo>i:nth-child(2){
  font-size: 300px;
  right: -20px;
  position: absolute;bottom:  -20px;
  transform: rotate(-30deg);
  z-index: 1;
}
</style>